import { LayoutStore, LayoutState } from './layout.store';
import { Injectable, RendererFactory2 } from '@angular/core';
import { Language } from '../../shared/interfaces/language.interface';
import { TranslocoService } from '@ngneat/transloco';
import { DateAdapter } from '@angular/material/core';
import { LayoutQuery } from './layout.query';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  constructor(
    private layoutStore: LayoutStore,
    private layoutQuery: LayoutQuery,
    private translocoService: TranslocoService,
    private dateAdapter: DateAdapter<Date>,
    private render: RendererFactory2
  ) {}

  get selectedLanguage() {
    return this.layoutQuery.layoutState.language;
  }

  updateLayout(layoutState: Partial<LayoutState>) {
    this.layoutStore.update(() => layoutState);
  }

  selectLanguage(language: Language) {
    this.updateLayout({ language });
    this.translocoService.setActiveLang(language.code);
    this.dateAdapter.setLocale(language.locale);
    this.setDirection();
  }

  setDirection() {
    const renderer = this.render.createRenderer(null, null);
    renderer.setAttribute(document.body, 'dir', this.selectedLanguage.dir);
  }
}
